import BaseApiClient from '../BaseApiClient';
import type { StageWorkflow, StageWorkflowStatus } from '@/interfaces/StageWorkflow.interface';
export { crmProductWorkflowQueryKeys } from './query-keys';
export { useCrmProductWorkflowsQuery } from './use-pipeline-stage-workflow-queries';

export type CrmProductWorkflowListItem = StageWorkflow;

export type CrmProductWorkflowCatalog = {
  productId: string | null;
  workflows: CrmProductWorkflowListItem[];
};

function normalizeStatus(value: unknown): StageWorkflowStatus {
  if (typeof value === 'string' && value.toLowerCase() === 'draft') {
    return 'draft';
  }
  return 'live';
}

function mapWorkflow(raw: Record<string, unknown>): StageWorkflow {
  return {
    id: String(raw.id ?? ''),
    name: String(raw.name ?? ''),
    description:
      raw.description == null || raw.description === ''
        ? null
        : String(raw.description),
    status: normalizeStatus(raw.status)
  };
}

/**
 * CRM tenant product (PBv2) workflows for pipeline stages.
 */
export class ApiPipelineStageWorkflows extends BaseApiClient {
  async listCrmProductWorkflows(): Promise<CrmProductWorkflowCatalog> {
    const res = await this.client.get('/crm-product/workflows');
    const payload = (res.data ?? {}) as Record<string, unknown>;
    const rows = (payload.data ?? []) as Record<string, unknown>[];
    const productId =
      typeof payload.product_id === 'string' && payload.product_id
        ? payload.product_id
        : null;

    if (!Array.isArray(rows)) {
      return { productId, workflows: [] };
    }

    return {
      productId,
      workflows: rows.map(mapWorkflow).filter((w) => w.id && w.name)
    };
  }
}
